import script from "./xt_img.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_img.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__